import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    // Calculate the path length for the triangle
    const path = this.element
    const length = path.getTotalLength()
    
    // Set the dash array and offset based on the actual path length
    path.style.strokeDasharray = length
    path.style.strokeDashoffset = length
    
    // Trigger the animation
    requestAnimationFrame(() => {
      path.style.transition = 'stroke-dashoffset 2s ease-out'
      path.style.strokeDashoffset = '0'
    })
  }
} 